export default __webpack_public_path__ + "static/media/slide4.d6307fd5.jpg";